import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';
import { Loader2, Lock, LogIn } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthModal = ({ open, onOpenChange }) => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, formData);
      login(data.access_token, data.user);
      toast.success('Connexion réussie');
      onOpenChange(false);
      if (data.user?.is_admin) {
        navigate('/admin');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Identifiants incorrects');
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[400px] p-0 bg-white border-0 shadow-2xl rounded-xl" data-testid="auth-modal">
        <div className="form-card-header rounded-t-xl">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-[#1E3A5F]/10 flex items-center justify-center">
              <Lock className="w-5 h-5 text-[#1E3A5F]" />
            </div>
            <div>
              <DialogTitle className="text-lg font-bold text-[#1E3A5F]">Administration</DialogTitle>
              <DialogDescription className="text-[#6B7C93] text-sm mt-0.5">Accès réservé aux administrateurs</DialogDescription>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-5">
          <div className="form-group">
            <Label className="form-label">Email</Label>
            <Input name="email" type="email" value={formData.email} onChange={handleChange} required className="form-input" placeholder="admin@urbanik.net" data-testid="auth-email-input" />
          </div>
          <div className="form-group">
            <Label className="form-label">Mot de passe</Label>
            <Input name="password" type="password" value={formData.password} onChange={handleChange} required className="form-input" placeholder="&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;" data-testid="auth-password-input" />
          </div>
          <button type="submit" disabled={loading} className="form-submit-btn w-full" data-testid="auth-submit-btn">
            {loading ? (<><Loader2 className="w-4 h-4 mr-2 animate-spin" />Connexion...</>) : (<><LogIn className="w-4 h-4 mr-2" />Se connecter</>)}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AuthModal;
